export const INFO_STEP = 1;

export const PASSWORD_STEP = 2;

export const SUCCESS_STEP = 3;

export const TOTAL_STEPS = 3;
